import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Dependencies
import moment from 'moment';

const BlackoutList = observer(class BlackoutList extends React.Component {
  render() {
    const { translation } = this.props;
    const { BlackoutStore, SessionStore } = this.props.store;
    const { blackoutDates } = BlackoutStore;
    const { userTimezone } = SessionStore;

    if(blackoutDates.length > 0) {
      return (
        <div className="note note--full">
          <p>{translation.heading}</p>

          <ul>
            {blackoutDates.map(
              (blackoutDate, i) =>
              <li key={i}>
                {
                  moment(blackoutDate.startDate)
                        .tz(userTimezone)
                        .format('M/D/YYYY h:mma')
                }–{
                  moment(blackoutDate.endDate)
                        .tz(userTimezone)
                        .format('M/D/YYYY h:mma')
                }
              </li>
            )}
          </ul>
        </div>
      )
    }

    return null;
  }
})

export default translate('BlackoutList')(BlackoutList);



// WEBPACK FOOTER //
// ./src/app/components/BlackoutDates/BlackoutList.js